export const ACTION_LOGIN = `userLoginIn`
export const ACTION_LOGOUT = `logout`
export const ACTION_USER_UPDATED = `userUpdated`
